import React, { ReactElement, ReactNode } from 'react'
import { EndContent, StartContent } from '../../data'
import { SettingLabel } from '../../wayfinding/setting-label/SettingLabel'
import { SelectItemPublic } from '../select-item/SelectItem'
import { SelectSectionPublic } from '../select-section/SelectSection'

export const SelectLabel = (props: React.ComponentProps<typeof SettingLabel>) => (
  <SettingLabel {...props} />
)
export const SelectStartContent = (props: React.ComponentProps<typeof StartContent>) => (
  <StartContent {...props} />
)
export const SelectEndContent = (props: React.ComponentProps<typeof EndContent>) => (
  <EndContent {...props} />
)

export const SelectItem = (props: React.ComponentPropsWithoutRef<typeof SelectItemPublic>) => (
  <SelectItemPublic {...props} />
)

type CascadeItemProps = {
  children: ReactNode
  'data-id'?: string
  'data-test-id'?: string
  description?: string
  endContent?: React.ReactNode
  startContent?: React.ReactNode
  isDisabled?: boolean
  label: string
  value: string
}
export const CascadeSelectItem: (props: CascadeItemProps) => ReactElement = () => (
  <>
    this component is never really rendered, it's using SelectItemInternal under the hood in
    SelectListBase
  </>
)

export const SelectSection = (
  props: React.ComponentPropsWithoutRef<typeof SelectSectionPublic>
) => <SelectSectionPublic {...props} />
